import { Grid, Typography } from "@mui/material";
import {
  getLatestNotifications,
  getNotificationList,
  notificationRead,
} from "store/slices/notification/notificationSlice";

import BackButton from "components/BackButton";
import { Container } from "@mui/system";
import ListNotification from "components/layout/Notification/Component/ListNotification";
import Pagination from "components/Pagination";
import useDispatch from "hooks/useDispatch";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROUTE_PATHS } from "routes/paths";

function Notifications() {
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const pageNumber = searchParams.get("page") || 1;
  const pageSize = searchParams.get("perPage") || 10;

  const allNotifications = useSelector(
    (state) => state.notification.allNotifications
  );

  const handleNotificationClick = async (notification) => {
    await dispatch(notificationRead(notification.id), "اعلان خوانده شد");
    dispatch(getLatestNotifications());
    await dispatch(getNotificationList({ pageNumber, pageSize }));
  };

  const handleChangePaginate = ({ page, perPage }) => {
    dispatch(getNotificationList({ pageNumber: page, pageSize: perPage }));
  };

  useEffect(() => {
    dispatch(getNotificationList({ pageNumber, pageSize }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isShowAll = true;

  return (
    <Container>
      <Grid container>
        <Grid item xs={6}>
          <BackButton text="بازگشت" to={ROUTE_PATHS.market} />
        </Grid>

        <Grid item xs={6}>
          <Typography variant="h3" color="text.main" textAlign="right">
            اعلانا‌ت
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <ListNotification
            notifications={allNotifications?.data}
            onNotificationClick={handleNotificationClick}
            isShowAll={isShowAll}
          />
        </Grid>

        <Grid item xs={12}>
          <Pagination
            perPage={allNotifications?.pageSize}
            count={allNotifications?.totalPages}
            onChange={handleChangePaginate}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Notifications;
